import ModalForm from './component';
import { ModalFormProps } from './types';

export default ModalForm;
export type { ModalFormProps };
